import React, { Component, useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { Link, Element } from 'react-scroll';
import cn from 'classnames';
import _ from 'lodash';
import VisibilitySensor from 'react-visibility-sensor';
import News from './News';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Autoplay } from 'swiper';
import 'swiper/swiper.min.css';
import AOS from 'aos';
import _Modal from '../../modals/index';
import 'aos/dist/aos.css';
import DemoRequestModal from '../../modals/DemoRequestModal';

import * as constants from '../../constants';
import Segment from '../../helpers/segment';
import CopyLink from '../generics/CopyLink';
import useScroll from '../../hooks/useScroll';
import TermsOfUseModal from '../../modals/TermsOfUseModal';
import PrivacyPolicyModal from '../../modals/PrivacyPolicyModal';
import AcceptableUsePolicyModal from '../../modals/AcceptableUsePolicyModal';
import BestViewingExperienceModal from '../../modals/BestViewingExperienceModal';

const LandingContainer = () => {
  const [haveScrolled, setHaveScrolled] = useState(false);
  const position = useScroll();

  useEffect(() => {
    // const aos = AOS;
    // aos.init({
    //   disable: 'mobile',
    //   duration: 2000,
    // });
  }, [position]);

  return (
    <div className="landing-container animated fadeIn">
      <div className="header">
        <div
          className={cn({
            'navbar-background': true,
            'have-scrolled': position !== 0,
          })}
        >
          <div className="navbar-container">
            <a className="logo" href="/">
              <img
                src="../assets/landing/logo-white.png"
                className="logoMark"
                alt="ArbiLex Logo"
              />
              <div className="arbilex">ArbiLex</div>
            </a>
            <div className="header-nav">
              {/* <Link smooth={true} offset={-90} to="why-arbilex">
                <Button className="landing-header-solutions">
                  Why ArbiLex
                </Button>
              </Link> */}
              <Link smooth={true} offset={-150} to="what-we-do">
                <Button className="landing-header-solutions">
                  What We Offer
                </Button>
              </Link>
              <Link smooth={true} offset={-100} to="who-we-are">
                <Button className="landing-header-solutions">Who We Are</Button>
              </Link>
              <Link smooth={true} offset={-50} to="news-n-events">
                <Button className="landing-header-solutions">
                  News & Events
                </Button>
              </Link>
            </div>
            <div className="nav-buttons">
              <_Modal
                children={DemoRequestModal}
                inline={{
                  el: (
                    <span
                      smooth="true"
                      offset={-50}
                      to="what-we-offer"
                      className={cn('landing-action-request-demo', {
                        'have-scrolled': position !== 0,
                      })}
                      id="request-demo-nav"
                      title="Contact us about seeing a demo"
                    >
                      Demo Request
                    </span>
                  ),
                }}
              />
              {/* </Link> */}
              <Button
                type="submit"
                id="landing-sign-in"
                className="landing-sign-in button-set-default"
                // onClick={openLoginModal}
              >
                <a href="https://afx.arbilex.co" target="_self">
                  Sign In
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <LandingPageElement
        className={'landing-top landing-section'}
        name={'hero-image'}
      >
        <div className="text-section">
          <div className="landing-header">
            <p className="landing-paragraph-text" id="landing-paragraph-text">
              <span className="landing-other-text">The</span>{' '}
              <span className="data-driven-orange">data-driven</span>{' '}
              marketplace<span className="landing-other-text"> for </span>{' '}
              <br className="hidden-break" />
              high-stakes litigation finance
            </p>
          </div>
          <div className="landing-subheader-mobile">
            <div>
              The <span>data-driven </span>
              <>marketplace for </>
              high-stakes litigation finance
            </div>
          </div>
          <div className="landing-numbers" id="landing-numbers">
            <div
              className="landing-numbers-container"
              id="landing-numbers-container"
            >
              <div className="top-left-sq">{''}</div>
              <div className="numbers-container" id="numbers-container">
                <Swiper
                  className="mySwiper"
                  autoplay={{
                    delay: 4000,
                    disableOnInteraction: false,
                  }}
                  grabCursor={true}
                  slidesPerView={3}
                  loop={true}
                  speed={1000}
                  modules={[Autoplay]}
                >
                  <SwiperSlide>
                    <div className="numbers-subsection">
                      <div>
                        <h3>$30B+</h3>
                        <p>worth of cases sourced, vetted, or priced</p>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="numbers-subsection">
                      <h3>95%</h3>
                      <p>
                        avg. out-of-sample win rate for cases predicted to have
                        a chance of success over 90%
                      </p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="numbers-subsection">
                      <h3>89%</h3>
                      <p>
                        avg. out-of-sample win rate for cases predicted to have
                        a chance of success over 75%
                      </p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="numbers-subsection">
                      <h3>78%</h3>
                      <p>
                        avg. out-of-sample win rate for cases predicted to have
                        a chance of success over 50%
                      </p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="numbers-subsection">
                      <h3>9,000,000+</h3>
                      <p>cases in the training dataset</p>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
              <div className="bottom-right-sq">{''}</div>
            </div>
            <div className="tablet-numbers-container">
              <div className="top-left-sq">{''}</div>
              <div className="tablet-numbers">
                <Swiper
                  className="mySwiper"
                  autoplay={{
                    delay: 4000,
                    disableOnInteraction: false,
                  }}
                  grabCursor={true}
                  slidesPerView={2}
                  loop={true}
                  speed={1000}
                  modules={[Autoplay]}
                >
                  <SwiperSlide>
                    <div className="tablet-numbers-paragraph-holder">
                      <p className="tablet-numbers-title">$30B+</p>
                      worth of cases sourced, vetted, or priced
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="tablet-numbers-paragraph-holder">
                      <p className="tablet-numbers-title">95%</p>
                      avg. out-of-sample win rate for cases predicted to have a
                      chance of success over 90%
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="tablet-numbers-paragraph-holder">
                      <p className="tablet-numbers-title">89%</p>
                      avg. out-of-sample win rate for cases predicted to have a
                      chance of success over 75%
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="tablet-numbers-paragraph-holder">
                      <p className="tablet-numbers-title">78%</p>
                      avg. out-of-sample win rate for cases predicted to have a
                      chance of success over 50%
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="tablet-numbers-paragraph-holder">
                      <p className="tablet-numbers-title">9,000,000+</p>
                      cases in the training dataset
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
              <div className="bottom-right-sq">{''}</div>
            </div>
            <div className="mobile-numbers-container">
              <div className="top-left-sq">{''}</div>
              <div className="mobile-numbers">
                <Swiper
                  className="mySwiper"
                  autoplay={{
                    delay: 4000,
                    disableOnInteraction: false,
                  }}
                  slidesPerView={1}
                  grabCursor={true}
                  loop={true}
                  speed={1000}
                  modules={[Autoplay]}
                >
                  <SwiperSlide>
                    <div className="mobile-numbers-paragraph-holder">
                      <p className="mobile-numbers-title">$30B+</p>
                      worth of cases sourced, vetted, or priced
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="mobile-numbers-paragraph-holder">
                      <p className="mobile-numbers-title">95%</p>
                      avg. out-of-sample win rate for cases predicted to have a
                      chance of success over 90%
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="mobile-numbers-paragraph-holder">
                      <p className="mobile-numbers-title">89%</p>
                      avg. out-of-sample win rate for cases predicted to have a
                      chance of success over 75%
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="mobile-numbers-paragraph-holder">
                      <p className="mobile-numbers-title">78%</p>
                      avg. out-of-sample win rate for cases predicted to have a
                      chance of success over 50%
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="mobile-numbers-paragraph-holder">
                      <p className="mobile-numbers-title">9,000,000+</p>
                      cases in the training dataset
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>

              <div className="bottom-right-sq">{''}</div>
            </div>
          </div>
        </div>
        <div className="scroll-down">
          <Link
            className="scroll-to-product"
            offset={-90}
            smooth="true"
            to="what-we-offer"
          >
            <img
              className="arrow-down"
              src="../assets/landing/arrow-down.png"
              alt=""
            />
            <img
              className="arrow-down-mobile"
              src="../assets/landing/down-arrow.svg"
              alt=""
            />
          </Link>
        </div>
      </LandingPageElement>
      <LandingPageElement
        className={'landing-offerings'}
        name={'what-we-offer'}
      >
        <div className="landing-offerings-container">
          <div className="landing-offerings-spacing-container">
            <div
              className="landing-section-title landing-offerings-title"
              name={'what-we-do'}
            >
              WHAT WE OFFER
            </div>
            <div className="landing-offerings-carousel-container">
              <Swiper
                id="landing-offerings-carousel"
                className="landing-offerings-carousel"
                loop={true}
                spaceBetween={250}
                autoplay={{
                  delay: 6000,
                  disableOnInteraction: true,
                }}
                grabCursor={true}
                speed={1500}
                modules={[Autoplay]}
              >
                <SwiperSlide id="landing-offerings-carousel-slide-1">
                  <div className="landing-offerings-carousel-slide">
                    <div className="landing-offerings-carousel-slide-left">
                      <div className="landing-offerings-carousel-slide-left-body-container">
                        <div className="landing-offerings-carousel-slide-left-text-container">
                          <div className="landing-offerings-carousel-slide-left-title">
                            AI-Augmented Case Rating
                          </div>
                          <div className="landing-offerings-carousel-slide-left-body">
                            We have been working on the application of machine
                            learning to litigation outcome predictions since
                            2019. Our models are built in-house, optimized and
                            selected based on out-of-sample performance metrics.
                            Our AI predictions have given our clients an
                            unparalleled quantitative edge over their
                            competitors who use a solely qualitative approach of
                            case assessment.
                          </div>
                        </div>
                        <_Modal
                          children={DemoRequestModal}
                          inline={{
                            el: (
                              <a
                                className="landing-offerings-carousel-slide-left-call-to-action"
                                id="request-demo-nav"
                                title="Contact us about seeing a demo"
                              >
                                Demo request
                              </a>
                            ),
                          }}
                        />
                      </div>
                      <div className="landing-offerings-carousel-slide-left-slide-indicator">
                        <div className="swiper-custom-numbers-and-pagination">
                          <div
                            id="left-number"
                            className="swiper-number-left  swiper-numbers"
                          >
                            01
                          </div>
                          <div className="swiper-custom-pagination-container">
                            <div className="swiper-pagination-bullet swiper-pagination-bullet-active" />
                            <div className="swiper-pagination-bullet" />
                            <div className="swiper-pagination-bullet" />
                          </div>
                          <div
                            id="right-number"
                            className="swiper-number-right swiper-numbers"
                          >
                            03
                          </div>
                        </div>
                      </div>
                    </div>
                    <img
                      className="landing-offerings-carousel-slide-right-image-container"
                      src="https://arbilex-static-assets.s3.us-east-1.amazonaws.com/afx%20images/poc14.jpg"
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide id="landing-offerings-carousel-slide-2">
                  <div className="landing-offerings-carousel-slide">
                    <div className="landing-offerings-carousel-slide-left">
                      <div className="landing-offerings-carousel-slide-left-body-container">
                        <div className="landing-offerings-carousel-slide-left-text-container">
                          <div className="landing-offerings-carousel-slide-left-title">
                            High-Velocity Origination
                          </div>
                          <div className="landing-offerings-carousel-slide-left-body">
                            ArbiLex Funding Exchange (AFX) offers a continuous,
                            AI-rated case pipeline that is available by
                            subscription. Our AI rates new case filings in
                            seconds, empowering our clients to accurately assess
                            top of funnel dealflows, at an unprecedented scale.
                          </div>
                        </div>
                        <a
                          href="https://afx.arbilex.co/"
                          className="landing-offerings-carousel-slide-left-call-to-action"
                        >
                          Visit AFX
                        </a>
                      </div>
                      <div className="landing-offerings-carousel-slide-left-slide-indicator">
                        <div className="swiper-custom-numbers-and-pagination">
                          <div
                            id="left-number"
                            className="swiper-number-left  swiper-numbers"
                          >
                            01
                          </div>
                          <div className="swiper-custom-pagination-container">
                            <div className="swiper-pagination-bullet" />
                            <div className="swiper-pagination-bullet swiper-pagination-bullet-active" />
                            <div className="swiper-pagination-bullet" />
                          </div>
                          <div
                            id="right-number"
                            className="swiper-number-right swiper-numbers"
                          >
                            03
                          </div>
                        </div>
                      </div>
                    </div>
                    <img
                      className="landing-offerings-carousel-slide-right-image-container"
                      src="https://arbilex-static-assets.s3.amazonaws.com/afx+images/poc10.jpg"
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide id="landing-offerings-carousel-slide-3">
                  <div className="landing-offerings-carousel-slide">
                    <div className="landing-offerings-carousel-slide-left">
                      <div className="landing-offerings-carousel-slide-left-body-container">
                        <div className="landing-offerings-carousel-slide-left-text-container">
                          <div className="landing-offerings-carousel-slide-left-title">
                            Private Marketplace
                          </div>
                          <div className="landing-offerings-carousel-slide-left-body">
                            We work closely with both investors seeking
                            litigation finance opportunities and claimholders
                            seeking capital for their cases. Please reach out to
                            us to discuss how we can support your organization’s
                            unique litigation data and/or financing needs.
                          </div>
                        </div>
                        <_Modal
                          children={DemoRequestModal}
                          inline={{
                            el: (
                              <a
                                className="landing-offerings-carousel-slide-left-call-to-action"
                                id="request-demo-nav"
                                title="Contact us about seeing a demo"
                              >
                                Demo request
                              </a>
                            ),
                          }}
                        />
                      </div>
                      <div className="landing-offerings-carousel-slide-left-slide-indicator">
                        <div className="swiper-custom-numbers-and-pagination">
                          <div
                            id="left-number"
                            className="swiper-number-left  swiper-numbers"
                          >
                            01
                          </div>
                          <div className="swiper-custom-pagination-container">
                            <div className="swiper-pagination-bullet" />
                            <div className="swiper-pagination-bullet" />
                            <div className="swiper-pagination-bullet swiper-pagination-bullet-active" />
                          </div>
                          <div
                            id="right-number"
                            className="swiper-number-right swiper-numbers"
                          >
                            03
                          </div>
                        </div>
                      </div>
                    </div>
                    <img
                      className="landing-offerings-carousel-slide-right-image-container"
                      src="https://arbilex-static-assets.s3.us-east-1.amazonaws.com/afx%20images/poc12.jpg"
                    />
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </LandingPageElement>
      <LandingPageElement className={'landing-who'} name={'who-we-are'}>
        <div className="landing-who-container">
          <div className="landing-who-content-area">
            <div className="landing-who-text-container">
              <div className="landing-section-title">WHO WE ARE</div>
              <div className="landing-who-body-container">
                <div className="landing-who-text-mobile">
                  <div className="mobile-text-holder">
                    <span className="landing-who-text-bold">We are</span>{' '}
                    lawyers, AI and machine learning scientists, engineers, and
                    designers from Harvard, MIT, and other leading institutions.{' '}
                    <span className="landing-who-text-bold">We believe</span>{' '}
                    <span className="landing-who-text-highlight">
                      diverse perspectives{' '}
                    </span>
                    ,{' '}
                    <span className="landing-who-text-highlight">
                      interdisciplinary{' '}
                    </span>{' '}
                    <span className="landing-who-text-highlight">
                      approaches
                    </span>{' '}
                    and a{' '}
                    <span className="landing-who-text-highlight">
                      fundamental passion for science
                    </span>{' '}
                    lead to the best decisions.{' '}
                    <span className="landing-who-text-bold">We look for</span>{' '}
                    curious minds with a balance of global ambitions and
                    resourceful pragmatism.
                  </div>
                  <div className="landing-who-btn-container">
                    <a
                      to="https://angel.co/company/arbilex"
                      href="https://angel.co/company/arbilex"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="landing-who-join-our-team"
                    >
                      Explore open positions
                    </a>
                  </div>
                </div>
                <div className="landing-who-text">
                  <div className="landing-who-text-top">
                    <span className="landing-who-text-bold">We are</span>{' '}
                    lawyers, AI and machine learning scientists, engineers, and
                    designers from Harvard, MIT, and other leading institutions.{' '}
                    <br />
                    <br />
                    <span className="landing-who-text-bold">
                      We believe
                    </span>{' '}
                    <span className="landing-who-text-highlight">diverse </span>{' '}
                    <span className="landing-who-text-highlight">
                      {' '}
                      perspectives
                    </span>
                    ,{' '}
                    <span className="landing-who-text-highlight">
                      interdisciplinary
                    </span>{' '}
                    <span className="landing-who-text-highlight">
                      approaches
                    </span>{' '}
                    and a fundamental{' '}
                    <span className="landing-who-text-highlight">passion</span>{' '}
                    <span className="landing-who-text-highlight"> for</span>{' '}
                    <span className="landing-who-text-highlight"> science</span>{' '}
                    lead to the best decisions.
                    <br />
                    <br />
                    <span className="landing-who-text-bold">
                      We look for
                    </span>{' '}
                    curious minds with a balance of global ambitions and
                    resourceful pragmatism.
                  </div>
                  <div className="landing-who-btn-container">
                    <a
                      to="https://angel.co/company/arbilex"
                      href="https://angel.co/company/arbilex"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="landing-who-join-our-team"
                    >
                      Explore open positions
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LandingPageElement>
      <LandingPageElement className={'landing-media'} name={'news-n-events'}>
        <div className="landing-media-container">
          <div className="landing-section-title landing-media-title">
            NEWS & EVENTS
          </div>
          <div className="landing-media-table">
            <div className="landing-media-table-body">
              <NewsComponent />
            </div>
          </div>
        </div>
      </LandingPageElement>
      <LandingPageElement className={'landing-footer'} name={'footer'}>
        <div className="landing-footer-top-section">
          <a className="logo" href="/">
            <img
              src="../assets/landing/logo-black.png"
              className="logoMark"
              alt="ArbiLex Logo"
            />
            <div className="logo-text">ArbiLex</div>
          </a>
        </div>
        <div className="landing-footer-mid-section">
          <div className="landing-footer-table-of-contents-container">
            <div className="landing-footer-table-of-contents-title landing-footer-title">
              TABLE OF CONTENTS
            </div>
            <div className="landing-footer-table-of-contents-content-container">
              <div className="landing-footer-table-of-contents">
                <Link
                  smooth={true}
                  to="hero-image"
                  className="landing-footer-table-of-contents-link"
                >
                  Our Mission
                </Link>
                {/* <Link
                  smooth={true}
                  to="why-arbilex"
                  className="landing-footer-table-of-contents-link"
                >
                  Why ArbiLex
                </Link> */}
                <Link
                  smooth={true}
                  to="what-we-do"
                  offset={-150}
                  className="landing-footer-table-of-contents-link"
                >
                  What We Offer
                </Link>
                <Link
                  smooth={true}
                  offset={-100}
                  to="who-we-are"
                  className="landing-footer-table-of-contents-link"
                >
                  Who We Are
                </Link>
                <Link
                  smooth={true}
                  to="news-n-events"
                  offset={-100}
                  className="landing-footer-table-of-contents-link"
                >
                  News & Events
                </Link>
              </div>
            </div>
          </div>
          <div className="landing-footer-support-container">
            <div className="landing-footer-support-title landing-footer-title">
              SUPPORT
            </div>
            <div className="landing-footer-support">
              <div className="landing-footer-support-link">
                <a
                  className="email"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={constants.BUG_REPORTING_LINK}
                >
                  Report an Issue
                </a>
              </div>
              <div className="landing-footer-support-link">
                <_Modal
                  children={BestViewingExperienceModal}
                  inline={{
                    el: (
                      <span
                        smooth="true"
                        offset={-50}
                        to="what-we-do"
                        className="best-viewing-experience"
                        // id="request-demo-nav"
                        // title="For the best viewing experience, please use Chrome on a large enough screen preferably a desktop or tablet device."
                      >
                        Best Viewing Experience
                      </span>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="landing-footer-contact-us-container">
            <div className="landing-footer-contact-us landing-footer-title">
              CONTACT US
            </div>
            <div className="landing-footer-contact-us">
              <div className="landing-footer-contact-us-link">
                <CopyLink color={'black'} text={'hello@arbilex.co'} />
              </div>
              <div className="landing-footer-contact-us-link">
                <div className="address">
                  Harvard Innovation Labs<br />
                  125 Western Ave., Allston, MA 02134
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="landing-footer-bottom-section">
          <div className="landing-footer-bottom-section-line" />
          <div className="landing-footer-bottom-section-ArbiLex-social-container">
            <ul className="landing-footer-bottom-section-ArbiLex-social">
              <li className="landing-footer-bottom-section-ArbiLex-social-item">
                <a
                  to="https://angel.co/company/arbilex"
                  href="https://angel.co/company/arbilex"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {/* <?xml version="1.0" encoding="UTF-8"?>*/}
                  <svg
                    width="13px"
                    height="18px"
                    viewBox="0 0 13 18"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    {/* <!-- Generator: Sketch 57.1 (83088) - https://sketch.com --> */}
                    <title>Angellist-logo</title>
                    <desc>Created with Sketch.</desc>
                    <g
                      id="Landing-Page-Revamp"
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        id="Desktop-HD"
                        transform="translate(-675.000000, -4173.000000)"
                        fill="#000000"
                        fillRule="nonzero"
                      >
                        <g id="Stacked-Group">
                          <g
                            id="Footer"
                            transform="translate(0.000000, 3950.000000)"
                          >
                            <g
                              id="Lower-Footer"
                              transform="translate(250.000000, 203.000000)"
                            >
                              <g
                                id="Group-19"
                                transform="translate(360.000000, 20.000000)"
                              >
                                <g
                                  id="Group-17"
                                  transform="translate(65.000000, 0.000000)"
                                >
                                  <path
                                    d="M10.5820389,7.57265625 C10.9933671,6.4265625 12.1781327,3.11132812 12.1781327,2.04960938 C12.1781327,1.11445313 11.6261796,0.33046875 10.6418046,0.33046875 C9.07383582,0.33046875 7.66758582,4.96054687 7.22813269,6.06445312 C6.88711707,5.0625 5.29102332,0 3.88477332,0 C2.79141394,0 2.27813269,0.805078125 2.27813269,1.81757813 C2.27813269,3.05859375 3.48047644,6.27539062 3.91641394,7.51289062 C3.69492957,7.43203125 3.45586707,7.36171875 3.21328894,7.36171875 C2.39063269,7.36171875 1.51524207,8.38476562 1.51524207,9.2109375 C1.51524207,9.52382812 1.68750769,9.96328125 1.79649207,10.2550781 C0.499226441,10.6066406 3.84135962e-06,11.4714844 3.84135962e-06,12.7757812 C-0.00350793386,15.3140625 2.40117957,18 5.78321082,18 C9.93164832,18 12.5121171,14.8851562 12.5121171,10.8667969 C12.5121171,9.3515625 12.2695389,7.98398438 10.5820389,7.57265625 Z M9.33750769,3.796875 C9.47813269,3.36445312 10.0793046,1.53632812 10.6418046,1.53632812 C10.9441483,1.53632812 11.0250077,1.84921875 11.0250077,2.09882812 C11.0250077,2.7703125 9.66797644,6.47929688 9.36914832,7.30195312 L8.17383582,7.09101562 L9.33750769,3.796875 Z M3.38203894,1.69804688 C3.38203894,1.2796875 3.89180457,0.09140625 5.00977332,3.35390625 L6.22617957,6.88007812 C5.67774207,6.834375 5.25235144,6.77460937 4.98164832,6.92929687 C4.59844519,5.91679687 3.38203894,2.72109375 3.38203894,1.69804688 Z M3.30117957,8.578125 C4.33125769,8.578125 5.66016394,11.9039063 5.66016394,12.3539062 C5.66016394,12.5332031 5.48789832,12.7546875 5.28750769,12.7546875 C4.55274207,12.7546875 2.58399207,10.0511719 2.58399207,9.31992187 C2.58750769,9.04921875 3.03047644,8.578125 3.30117957,8.578125 L3.30117957,8.578125 Z M9.78047644,15.1277344 C8.75742957,16.2527344 7.44961707,16.8363281 5.92383582,16.8363281 C3.83555457,16.8363281 2.18672644,15.6902344 1.39219519,13.7320313 C0.791023316,12.20625 1.52578894,11.3308594 2.11641394,11.3308594 C2.51719519,11.3308594 4.02539832,13.4507813 4.02539832,13.9007812 C4.02539832,14.0730469 3.75469519,14.1925781 3.61407019,14.1925781 C3.04805457,14.1925781 2.82657019,13.6476562 1.81758582,12.3855469 C0.773445191,13.4296875 2.53828894,15.440625 3.86719519,15.440625 C4.78477332,15.440625 5.38242957,14.5898438 5.20313269,13.9640625 C5.33321082,13.9640625 5.49492957,13.9746094 5.61446082,13.9429688 C5.65313269,14.8957031 5.93438269,16.03125 7.08047644,16.1121094 C7.08047644,16.0804688 7.15078894,15.8625 7.15078894,15.8519531 C7.15078894,15.2402344 6.77813269,14.7058594 6.77813269,14.0835938 C6.77813269,13.0886719 7.54102332,12.1253906 8.31446082,11.5628906 C8.59571082,11.3519531 8.93672644,11.221875 9.26719519,11.1023437 C9.60821082,10.9722656 9.97032019,10.8210937 10.2304764,10.5609375 C10.1918046,10.1671875 10.0300858,9.81914062 9.63633582,9.81914062 C8.66250769,9.81914062 5.39649207,9.95976562 5.39649207,8.4234375 C5.39649207,8.18789062 5.40000769,7.96289062 6.00821082,7.96289062 C7.14375769,7.96289062 10.0265702,8.24414062 10.8703202,8.9859375 C11.5066483,9.55195313 11.7246171,12.965625 9.78047644,15.1277344 Z M6.31407019,10.6980469 C6.65508582,10.8070312 7.00664832,10.8386719 7.35821082,10.9089844 C7.09805457,11.0988281 6.86602332,11.3308594 6.64453894,11.5804687 C6.54610144,11.2816406 6.42657019,10.9898438 6.31407019,10.6980469 L6.31407019,10.6980469 Z"
                                    id="Angellist-logo"
                                  />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
              <li className="landing-footer-bottom-section-ArbiLex-social-item">
                <a
                  to="https://twitter.com/arbilexai"
                  href="https://twitter.com/arbilexai"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {/* <?xml version="1.0" encoding="UTF-8"?>*/}
                  <svg
                    width="21px"
                    height="16px"
                    viewBox="0 0 21 16"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    {/* <!-- Generator: Sketch 57.1 (83088) - https://sketch.com --> */}
                    <title>Twitter-logo</title>
                    <desc>Created with Sketch.</desc>
                    <g
                      id="Landing-Page-Revamp"
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        id="Desktop-HD"
                        transform="translate(-707.000000, -4175.000000)"
                        fill="#000000"
                        fillRule="nonzero"
                      >
                        <g id="Stacked-Group">
                          <g
                            id="Footer"
                            transform="translate(0.000000, 3950.000000)"
                          >
                            <g
                              id="Lower-Footer"
                              transform="translate(250.000000, 203.000000)"
                            >
                              <g
                                id="Group-19"
                                transform="translate(360.000000, 20.000000)"
                              >
                                <g
                                  id="Group-17"
                                  transform="translate(65.000000, 0.000000)"
                                >
                                  <path
                                    d="M50.4563278,5.90080101 C50.4690231,6.07198849 50.4690231,6.24321361 50.4690231,6.41440109 C50.4690231,11.635845 46.3446711,17.6521739 38.8065557,17.6521739 C36.4842029,17.6521739 34.3268507,17.0040479 32.5121171,15.8790962 C32.8420793,15.9157578 33.1593071,15.9279908 33.5019647,15.9279908 C35.4181831,15.9279908 37.1821744,15.3043685 38.5908127,14.2405069 C36.7887744,14.2038077 35.2786122,13.0665853 34.7582977,11.5013567 C35.0121171,11.5380182 35.2659169,11.5624843 35.5324414,11.5624843 C35.9004506,11.5624843 36.2684989,11.5135521 36.6111175,11.427996 C34.7329461,11.0611173 33.3242687,9.47146013 33.3242687,7.55162344 L33.3242687,7.50272886 C33.8699349,7.79620924 34.5045077,7.97962977 35.1770494,8.00405824 C34.0729825,7.29480458 33.3496594,6.08422155 33.3496594,4.71464645 C33.3496594,3.98096432 33.552668,3.30840983 33.908021,2.72144907 C35.9258023,5.11818667 38.9588219,6.68337772 42.3598118,6.85460283 C42.296374,6.56112245 42.2582879,6.25544666 42.2582879,5.94973323 C42.2582879,3.77307768 44.085717,2 46.3572883,2 C47.5374883,2 48.603469,2.47690091 49.3522219,3.2472822 C50.2785927,3.07609472 51.1669165,2.74591518 51.9537555,2.29348038 C51.6491449,3.21062067 51.0019549,3.98100196 50.1517172,4.47009829 C50.9766033,4.38454219 51.7760986,4.16438485 52.5121171,3.85870906 C51.9538336,4.64128576 51.2558231,5.33826873 50.4563278,5.90080101 Z"
                                    id="Twitter-logo"
                                  />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
              <li className="landing-footer-bottom-section-ArbiLex-social-item">
                <a
                  to="https://www.linkedin.com/company/arbilex"
                  href="https://www.linkedin.com/company/arbilex"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {/* <?xml version="1.0" encoding="UTF-8"?>*/}
                  <svg
                    width="19px"
                    height="18px"
                    viewBox="0 0 19 18"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    {/* <!-- Generator: Sketch 57.1 (83088) - https://sketch.com --> */}
                    <title>Linkedin-logo</title>
                    <desc>Created with Sketch.</desc>
                    <g
                      id="Landing-Page-Revamp"
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        id="Desktop-HD"
                        transform="translate(-747.000000, -4173.000000)"
                        fill="#000000"
                        fillRule="nonzero"
                      >
                        <g id="Stacked-Group">
                          <g
                            id="Footer"
                            transform="translate(0.000000, 3950.000000)"
                          >
                            <g
                              id="Lower-Footer"
                              transform="translate(250.000000, 203.000000)"
                            >
                              <g
                                id="Group-19"
                                transform="translate(360.000000, 20.000000)"
                              >
                                <g
                                  id="Group-17"
                                  transform="translate(65.000000, 0.000000)"
                                >
                                  <path
                                    d="M76.6432646,18 L72.807199,18 L72.807199,5.90163934 L76.6432646,5.90163934 L76.6432646,18 Z M74.7252318,4.42622951 C73.5032666,4.42622951 72.5121171,3.41887224 72.5121171,2.20267262 C72.5121171,0.986170118 73.5029623,0 74.7252318,0 C75.9475013,0 76.9383466,0.986170118 76.9383466,2.20267262 C76.9383466,3.41887224 75.9467856,4.42622951 74.7252318,4.42622951 Z M90.5081424,18 L86.8244384,18 L86.8244384,12.1145295 C86.8244384,10.7118796 86.7966158,8.9130923 84.9050807,8.9130923 C82.985723,8.9130923 82.691599,10.4370088 82.691599,12.0134741 L82.691599,18 L79.0039203,18 L79.0039203,5.90972378 L82.5445371,5.90972378 L82.5445371,7.55894902 L82.5962075,7.55894902 C83.0890639,6.60902762 84.2929849,5.60655738 86.0891284,5.60655738 C89.8252978,5.60655738 90.5121171,8.10869077 90.5121171,11.3586346 L90.5121171,18 L90.5081424,18 Z"
                                    id="Linkedin-logo"
                                  />
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </a>
              </li>
            </ul>
          </div>
          <div className="landing-footer-bottom-section-text">
            <div className="copyright">
              All Rights Reserved &copy; 2023 <strong>Arbi, Inc.</strong>
            </div>
            <div>
              <_Modal
                children={AcceptableUsePolicyModal}
                inline={{
                  el: (
                    <button className="acceptable-use-policy">
                      Acceptable Use Policy
                    </button>
                  ),
                }}
              />
            </div>
            <div className="policy-terms-container">
              <_Modal
                children={PrivacyPolicyModal}
                inline={{
                  el: (
                    <button className="acceptable-use-policy">
                      Privacy Policy
                    </button>
                  ),
                }}
              />
              &nbsp;and&nbsp;
              <_Modal
                children={TermsOfUseModal}
                inline={{
                  el: (
                    <button className="acceptable-use-policy">
                      Terms of Use
                    </button>
                  ),
                }}
              />
            </div>
          </div>
        </div>
      </LandingPageElement>
    </div>
  );
};

const LandingPageElement = (props) => {
  const [recordedVisibility, setRecordedVisibility] = useState(false);

  const onVisible = (is_visible) => {
    if (is_visible && !recordedVisibility) {
      setRecordedVisibility(true);
      const section_name = props?.name;
      Segment.track('Landing page section visible: ' + section_name, {
        section_name,
      });
    }
    return;
  };

  return (
    <VisibilitySensor onChange={onVisible} partialVisibility={true}>
      <Element className={props?.className} name={props?.name}>
        {props?.children}
      </Element>
    </VisibilitySensor>
  );
};

const NewsComponent = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(5);

  const indexLastPost = currentPage * postsPerPage;
  const indexFirstPost = indexLastPost - postsPerPage;
  const currentPosts = News.slice(indexFirstPost, indexLastPost);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(News.length / postsPerPage); i++) {
    pageNumbers.push(i);
  }

  const checkDisabledLeft = (e) => {
    e.persist();
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
    return e;
  };
  const checkDisabledRight = (e) => {
    e.persist();
    if (currentPage !== pageNumbers.length) {
      setCurrentPage(currentPage + 1);
    }
    return e;
  };

  return (
    <>
      <table className="news-event-holder">
        <Posts
          articles={currentPosts}
          postsPerPage={postsPerPage}
          currentPage={currentPage}
        />
      </table>
      <div className="pagination-container-centerer">
        <div className="pagination-container">
          <div
            onClick={(e) => checkDisabledLeft(e)}
            className={cn('pagination-div pagination-arrow', {
              disabled: currentPage === 1,
            })}
          >
            <a
              className={cn('pagination-link', {
                disabled: currentPage === 1,
              })}
            >
              <svg className="pagination-arrow-svg left" />
            </a>
          </div>
          <NewsPagination
            postsPerPage={postsPerPage}
            totalPosts={News.length}
            paginate={paginate}
            currentPage={currentPage}
          />
          <div
            onClick={(e) => checkDisabledRight(e)}
            className={cn('pagination-div pagination-arrow', {
              disabled: currentPage === pageNumbers.length,
            })}
          >
            <a
              className={cn('pagination-link', {
                disabled: currentPage === pageNumbers.length,
              })}
            >
              <svg className="pagination-arrow-svg right" />{' '}
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
const Posts = ({ articles }) => {
  return (
    <tbody className="landing-media-tbody">
      {articles.map((article, i) => (
        <tr className="landing-media-table-row" key={i}>
          <td className="landing-media-table-text">
            <div className="landing-media-item">
              <div className="landing-media-item-date">{article.date}</div>
              <a href={article.link} target="_blank" rel="noopener noreferrer">
                <div className="landing-media-item-title">{article.title}</div>
              </a>
              <div className="landing-media-item-from">{article.source}</div>
            </div>
          </td>
          <td className="landing-media-table-img" />
        </tr>
      ))}
    </tbody>
  );
};

const NewsPagination = ({
  postsPerPage,
  totalPosts,
  paginate,
  currentPage,
}) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pageNumbers.push(i);
  }
  return (
    <div className="news-button-holder">
      {pageNumbers.map((number) => (
        <div key={number} className="pagination-div">
          <a
            onClick={() => paginate(number)}
            className={cn('pagination-link', {
              activePage: currentPage === number,
            })}
          >
            {number}
          </a>
        </div>
      ))}
    </div>
  );
};

export default LandingContainer;

//  <_Modal
//    children={modalToU}
//    inline={{
//      el: <span className="footer-modal-link">Terms of Use</span>,
//    }}
//  />;
